export enum Screen {
  Mobile_320 = 320,
  Mobile_375 = 375,
  Mobile_640 = 640,
  Tablet_768 = 768,
  Tablet_1024 = 1024,
  DESKTOP_1280 = 1280,
  Desktop_1440 = 1440,
}
